var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"outside"},[_c('titlePage',{attrs:{"item":_vm.title}}),_c('div',{staticClass:"outside-box"},[_c('chartsLine',{key:_vm.setRefresh,attrs:{"option":_vm.lineData,"id":"outsideBox"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }